// Constants
const COMPLIANCE_QUESTION_TYPE = 1;

export default {
    methods: {
        // Method to find the result of a dependent question based on its ID
        $_findDependentQuestionResult(dependentQuestionId, healthCheckSource) {
            if (!healthCheckSource.groups) {
                console.error('No groups available in healthCheckSource');
                return null;
            }

            for (let group of healthCheckSource.groups) {
                if (!group.items) continue;

                for (let item of group.items) {
                    if (item.id === dependentQuestionId) {
                        return item.result;
                    }
                }
            }

            return null;
        },
        // Method to determine if a question is a compliance question
        $_isComplianceQuestion(question, healthCheckSource) {
            if (question.questionType === COMPLIANCE_QUESTION_TYPE) return true;

            const override = question.questionTypeOverride;
            if (!override) return false;

            const foundDependentQuestionResult = this.$_findDependentQuestionResult(override.dependentQuestionId, healthCheckSource);
            
            if (foundDependentQuestionResult != null && foundDependentQuestionResult == override.dependentQuestionResult) {
                return override.newQuestionType;
            }

            return false;
        },
        // Method to determine if a question should be displayed
        $_shouldDisplayQuestion(question, healthCheckSource) {
            if (!question.questionDisplayCondition) return true;

            const condition = question.questionDisplayCondition;

            const foundDependentQuestionResult = this.$_findDependentQuestionResult(condition.dependentQuestionId, healthCheckSource);

            if (foundDependentQuestionResult != null) {
                return foundDependentQuestionResult == condition.dependentQuestionResult ? condition.display : !condition.display;
            }

            return !condition.display;
        },
        // Method to determine if a question is scorable
        $_isScorableQuestion(question, healthCheckSource) {
            return this.$_shouldDisplayQuestion(question, healthCheckSource) &&
            question.questionType !== 2
        },
    }
}